import styled from "styled-components";
import { css } from "styled-components";
import images from "../images";
import { responsiveMap } from "../../../../Grid/_utils/responsiveObserve";

export const _MargauxMotinPriceListRoot = styled("div")<{}>(() => {
  return css`
    background-image: url(${images.BgPrice});
    background-size: contain;
    background-repeat: no-repeat;
    position: relative;
    aspect-ratio: 195.49 / 178.96;
    background-position: 83% -11px;
    margin: -41px;
    max-width: 320px;

    .decoration-box {
      position: absolute;
      top: 5%;
      right: 33%;
      transform: rotate(23deg);
    }

    .margaux-motin-price-list {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 101px;
    }

    @media ${responsiveMap.maxLg} {
      margin-bottom: 0px;
    }
  `;
});
